<section class="sidebar-wrapper" [ngClass]="{ collapsedClass: collapsed }">
  <button class="toggle-btn" (click)="toggleChange()"></button>

  <div class="header">
    <img
      (click)="collapsed ? null : navigateHome()"
      [style.cursor]="collapsed ? 'default' : 'pointer'"
      src="assets/images/monkeypenLogo.avif"
      alt="Logo"
      draggable="false"
    />
  </div>
  <div class="nav-items-wrapper">
    <ul class="main-nav-list">
      <!-- Dashboard -->
      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/dashboard') }"
        (click)="navigateTo('/dashboard')"
      >
        <img
          src="assets/images/icons/dashboard.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Dashboard' : null"
          matTooltipPosition="right"
        />
        <h3>Dashboard</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/stories') }"
        (click)="navigateTo('/stories')"
        *appHasPermission="'VIEW_STORY'"
      >
        <img
          src="assets/images/icons/Stories.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Stories' : null"
          matTooltipPosition="right"
        />
        <h3>Stories</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/video') }"
        (click)="navigateTo('/video')"
        *appHasPermission="'VIEW_VIDEO_STORY'"
      >
        <img
          src="assets/images/icons/videoStory.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Videos' : null"
          matTooltipPosition="right"
        />
        <h3>Videos</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/poster') }"
        (click)="navigateTo('/poster')"
        *appHasPermission="'VIEW_POSTER'"
      >
        <img
          src="assets/images/icons/Posters.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Posters' : null"
          matTooltipPosition="right"
        />
        <h3>Posters</h3>
      </li>

      <li class="nav" [ngClass]="{ 'active-class': isRouteActive('/coloring-images') }"
        (click)="navigateTo('/coloring-images')" *appHasPermission="'VIEW_COLORING'">
        <img src="assets/images/icons/coloring-image.svg" alt="No Icon" [matTooltip]="collapsed ? 'coloringImage' : null"
          matTooltipPosition="right" />
        <h3>Coloring Images</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/challenges') }"
        (click)="navigateTo('/challenges')"
        *appHasPermission="'VIEW_CHALLENGE'"
      >
        <img
          src="assets/images/icons/challenges.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Challenges' : null"
          matTooltipPosition="right"
        />
        <h3>Challenges</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/badge') }"
        (click)="navigateTo('/badge')"
        *appHasPermission="'VIEW_BADGE'"
      >
        <img
          src="assets/images/icons/Badge.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Badges' : null"
          matTooltipPosition="right"
        />
        <h3>Badges</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/tags') }"
        (click)="navigateTo('/tags')"
        *appHasPermission="'VIEW_TAG'"
      >
        <img
          src="assets/images/icons/Tags.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Tags' : null"
          matTooltipPosition="right"
        />
        <h3>Tags</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/themes') }"
        (click)="navigateTo('/themes')"
        *appHasPermission="'VIEW_THEME'"
      >
        <img
          src="assets/images/icons/Category.svg"
          alt="icon Themes"
          [matTooltip]="collapsed ? 'Themes' : null"
          matTooltipPosition="right"
        />
        <h3>Themes</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/users') }"
        (click)="navigateTo('/users')"
        *appHasPermission="'VIEW_APP_USER'"
      >
        <img
          src="assets/images/icons/Users.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Users' : null"
          matTooltipPosition="right"
        />
        <h3>App Users</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{
          'active-class': isRouteActive('/plans-and-subscriptions')
        }"
        (click)="navigateTo('/plans-and-subscriptions')"
        *appHasPermission="'VIEW_FEATURE'"
      >
        <img
          src="/assets/images/icons/plans-and-subscriptions.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Plans and Subscriptions' : null"
          matTooltipPosition="right"
        />
        <h3>Plans and Subscriptions</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/roles') }"
        (click)="navigateTo('/roles')"
        *appHasPermission="'VIEW_ROLE'"
      >
        <img
          src="assets/images/icons/Roles.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Roles' : null"
          matTooltipPosition="right"
        />
        <h3>Roles</h3>
      </li>
      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/faq') }"
        (click)="navigateTo('/faq')"
        *appHasPermission="'VIEW_FAQ'"
      >
        <img
          src="assets/images/icons/FAQ.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'FAQ' : null"
          matTooltipPosition="right"
        />
        <h3>FAQ</h3>
      </li>
      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/info-pages') }"
        (click)="navigateTo('/info-pages')"
        *appHasPermission="'INFO_PAGES'"
      >
        <img
          src="assets/images/icons/static-page.svg"
          alt="icon Dashboard"
          [matTooltip]="collapsed ? 'Info page' : null"
          matTooltipPosition="right"
        />
        <h3>Info Pages</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/settings') }"
        (click)="navigateTo('/settings')"
        *appHasPermission="'VIEW_SETTINGS'"
      >
        <img
          src="assets/images/icons/settings.svg"
          alt="icon Settings"
          [matTooltip]="collapsed ? 'Settings' : null"
          matTooltipPosition="right"
        />
        <h3>Settings</h3>
      </li>

      <!-- Inventory -->
      <!-- <li class="nav dropdown-nav">
        <mat-accordion>
          <mat-expansion-panel [expanded]="mattabnumber == 1">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <img
                  src="assets/images/icons/dashboard.svg"
                  alt="icon content"
                  matTooltip="Content"
                  matTooltipPosition="right"
                />
                <h3>Content</h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sub-nav">
              <li
                [ngClass]="{ 'active-class': isRouteActive('/heh') }"
                (click)="navigateTo('/heh')"
                *appHasPermission="'ADD_IMAGE'"
              >
                ADD IMAGE
              </li>
              <li
                [ngClass]="{ 'active-class': isRouteActive('/heh') }"
                (click)="navigateTo('/heh')"
              >
                Stories
              </li>
              <li
                [ngClass]="{ 'active-class': isRouteActive('/heh') }"
                (click)="navigateTo('/heh')"
              >
                Sample
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </li> -->

      <!-- Sales -->
    </ul>
  </div>
</section>
